import { lazy } from 'react';
import AuthLayout from 'layout/auth/auth';
import { Navigate } from 'react-router-dom';

// Importing lazy-loaded components for different pages
const Login = lazy(() => import('pages/auth/login/login'));

const ResetPassword = lazy(() =>
  import('pages/auth/reset-password/reset-password')
);
const ForgetPassword = lazy(() =>
  import('pages/auth/forget-password/forget-password')
);
const OtpVerification = lazy(() =>
  import('pages/auth/otp-verification/otp-verification')
);
const EmailConfirmation = lazy(() =>
  import('pages/auth/email-confirmation/email-confirmation')
);
const UserSetPassword = lazy(() =>
  import('pages/auth/set-password/set-password')
);

// Importing Applicant Routes
const ApplicantSignup = lazy(() => import('pages/applicant/auth/signup'));
const ApplicantLogin = lazy(() => import('pages/applicant/auth/login/login'));

const ApplicantForgetPassword = lazy(() =>
  import('pages/applicant/auth/forget-password/forget-password')
);

const ApplicantResetPassword = lazy(() =>
  import('pages/applicant/auth/reset-password/reset-password')
);

const ApplicantOtpVerification = lazy(() =>
  import('pages/applicant/auth/otp-verification/otp-verification')
);
const ApplicantEmailConfirmation = lazy(() =>
  import('pages/applicant/auth/email-confirmation/email-confirmation')
);

// Array of public routes
export const publicRoutes = [
  {
    path: '/',
    layout: null,
    name: 'Root',
    permission: [],
    component: () => <Navigate to="/login" replace />
  },
  {
    name: 'Login',
    path: '/login',
    permission: [],
    component: Login,
    layout: AuthLayout
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'User-Setpassword',
    component: UserSetPassword,
    path: '/user/set-password'
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Forget-password',
    path: '/forget-password',
    component: ForgetPassword
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Reset-password',
    path: '/reset-password',
    component: ResetPassword
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Email-confirmation',
    path: '/email-confirmation',
    component: EmailConfirmation
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Otp-verification',
    path: '/otp-verification',
    component: OtpVerification
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Applicant-Signup',
    path: '/applicant/signup',
    component: ApplicantSignup
  },

  {
    permission: [],
    layout: AuthLayout,
    name: 'Applicant-Login',
    path: '/applicant/login',
    component: ApplicantLogin
  },

  {
    permission: [],
    layout: AuthLayout,
    name: 'Applicant-Otp-verification',
    path: '/applicant/otp-verification',
    component: ApplicantOtpVerification
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Applicant-Forget-password',
    path: '/applicant/forget-password',
    component: ApplicantForgetPassword
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Applicant-Reset-password',
    path: '/applicant/reset-password',
    component: ApplicantResetPassword
  },
  {
    permission: [],
    layout: AuthLayout,
    name: 'Applicant-Email-confirmation',
    path: '/applicant/email-confirmation',
    component: ApplicantEmailConfirmation
  }
];
